// extracted by mini-css-extract-plugin
module.exports = {"root":"LangMobileButtons_root__1H8Ne","button":"LangMobileButtons_button__nlvW0","active":"LangMobileButtons_active__1h5Oq"};